import React, { useState, useCallback } from 'react';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import filterTokens from '@amzn/meridian-tokens/base/icon/filter';

/**
 * FilterExpander — collapsible filter container for mobile (ported from v1
 * src/components/common/FilterExpander.js).
 *
 * Renders a "Filters" toggle button (filter icon + label). The wrapped `children` (and optional
 * `appliedFilters`) are COLLAPSED by default and revealed only when the toggle is clicked. On the
 * Induct Associate page this is what makes the mobile filter differ from desktop; the migrated
 * AssociateFilter had dropped it, so mobile rendered the filter inline and looked identical to
 * desktop (bug D496001686).
 */
export interface FilterExpanderProps {
  children?: React.ReactNode;
  /** Optional content (e.g. applied filter tags) shown alongside children when expanded. */
  appliedFilters?: React.ReactNode;
}

export const FilterExpander: React.FC<FilterExpanderProps> = ({
  children,
  appliedFilters,
}) => {
  const [open, setOpen] = useState(false);
  const onClick = useCallback(() => setOpen((prev) => !prev), []);

  return (
    <React.Fragment>
      <Button onClick={onClick} type="link" size="medium">
        <Icon tokens={filterTokens} /> Filters
      </Button>
      {open && (
        <React.Fragment>
          {children}
          {appliedFilters}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default FilterExpander;
